/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_GuideInputs */

const en_landing_nav_guide = /** @type {(inputs: Landing_Nav_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide`)
};

const zh_landing_nav_guide = /** @type {(inputs: Landing_Nav_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指南`)
};

/**
* | output |
* | --- |
* | "Guide" |
*
* @param {Landing_Nav_GuideInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_nav_guide = /** @type {((inputs?: Landing_Nav_GuideInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_GuideInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_nav_guide(inputs)
	return zh_landing_nav_guide(inputs)
});
export { landing_nav_guide as "landing.nav.guide" }